import { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
    const [lang, setLang] = useState(() => localStorage.getItem("tf_lang") || "id");

    useEffect(() => {
        localStorage.setItem("tf_lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    return <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
